var map = {
	"./10_blue.mp3": "c624",
	"./11_green.mp3": "ed22",
	"./12_purple.mp3": "ec13",
	"./13_pink.mp3": "6ad1",
	"./14_orange.mp3": "5425",
	"./47_pepper.mp3": "4466",
	"./48_carrot.mp3": "e0ec",
	"./49_tomato.mp3": "0678",
	"./8_red.mp3": "1fcf",
	"./9_yellow.mp3": "769b",
	"./M_Brilliant.mp3": "ae8a",
	"./M_Excellent.mp3": "4f8b",
	"./M_Fantastic.mp3": "817b",
	"./M_Great.mp3": "fe18",
	"./M_Perfect.mp3": "4860",
	"./M_Think again.mp3": "5b44",
	"./M_Try again.mp3": "941f",
	"./M_Very good.mp3": "1d7f",
	"./M_Well done.mp3": "a798",
	"./M_Work harder.mp3": "b1d9",
	"./click.mp3": "2e59",
	"./false.mp3": "e605",
	"./true.mp3": "c020"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e5eb";